document.addEventListener('DOMContentLoaded', function() {
    const scrollPhoneDesk = document.querySelector('.scroll-phone');
    const header = document.querySelector('.header-section');

    window.addEventListener('load', () => {
        let shouldShow = window.scrollY > header.offsetHeight;

        if (document.documentElement.clientWidth > 803) {
            if (shouldShow) {
                scrollPhoneDesk.classList.add('show');
            }
        }
    });

    function showPhone () {
        let shouldShow = window.scrollY > header.offsetHeight;

        if (shouldShow) {
            scrollPhoneDesk.classList.add('show');
        } else {
            scrollPhoneDesk.classList.remove('show');
        }
    }

    window.addEventListener('scroll', showPhone);
});

